const tag = {
    featured: 'Fremhevet',
}

export default tag;